import React from "react";
import styled from "styled-components";
import CommentLimitStatus from "./CommentLimitStatus";
import {shadedBackgroundColour} from "../../../style/styleConsts";

const CommentaryContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    min-height: 100px;
`;

const Title = styled.div`
    font-weight: bold;
`;

const CommentaryBox = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: stretch;
    border: 1px solid #d6d0c8;
    border-radius: 2px;
    background-color: ${ props => props.disabled ? shadedBackgroundColour : "#ffffff" };
`;

const CloseCommentary = styled.textarea`
    flex-grow: 1;
    resize: none;
    border-style: none;
    background-color: inherit;
    :focus {
        outline: none
    }
`;

const CommentaryEntry = ({title, textLimit = 4000, disabled, commentary, onCommentaryUpdated, commentaryRequired}) => {
    const placeholder = commentaryRequired ? "required" : null;

    return (
        <CommentaryContainer className="t-commentary">
            <Title>{title}</Title>
            <CommentaryBox disabled={disabled}>
                <CloseCommentary disabled={disabled}
                                 className="t-commentary-box"
                                 placeholder={placeholder}
                                 maxLength={textLimit}
                                 value={commentary}
                                 onChange={e => onCommentaryUpdated(e.target.value)}/>
                <CommentLimitStatus commentary={commentary}
                                    commentaryRequired={commentaryRequired}
                                    textLimit={textLimit}/>
            </CommentaryBox>
        </CommentaryContainer>
    );
};

export default CommentaryEntry;